import { __assign } from "tslib";
import { FileType } from '@office-start/document-types';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { logFeature } from '@office-start/telemetry-service';
export function logTagFeature(eventName, isSuccess, errorType) {
    logFeature({
        featureName: "HarmonyTag" /* KnownFeatureNames.HarmonyTag */,
        eventName: eventName,
        params: {
            Success: isSuccess !== null && isSuccess !== void 0 ? isSuccess : '',
            ErrorType: errorType !== null && errorType !== void 0 ? errorType : '',
        },
    });
}
export function logTagMetrics(tagIdMap) {
    scheduleWork(function () {
        var documentCounts = Array.from(tagIdMap.values()).map(function (val) { return val[1].size; });
        if (documentCounts.length) {
            documentCounts.sort(function (a, b) { return a - b; });
            var halfIndex = Math.floor(documentCounts.length / 2);
            var taggedItemsMedian = documentCounts.length % 2 === 1
                ? documentCounts[halfIndex]
                : (documentCounts[halfIndex] +
                    documentCounts[halfIndex - 1]) /
                    2;
            logFeature({
                featureName: "HarmonyTag" /* KnownFeatureNames.HarmonyTag */,
                eventName: 'TagMetrics',
                params: {
                    TaggedItemsMedian: taggedItemsMedian.toString() || '',
                },
            });
        }
    }, IDLE_VERYLOW_PRIORITY);
}
export function convertDocumentToCard(document) {
    var documentCard = __assign(__assign({}, document), { name: document.title, uniqueId: document.id, type: {
            value: (document.fileType || FileType.Unknown).toString(),
        } });
    // Delete the following properties because they are reserved names for MFS cards
    delete documentCard.title;
    delete documentCard.id;
    return documentCard;
}
//# sourceMappingURL=TagsUtils.js.map